import React from 'react';

type Props = {
  tabs: Array<{ label: string; value: string }> | Array<string>;
  activeTab: string;
  onChange: (selectedTab: string) => void;
  className?: string;
};

export default function TabSwitch({
  activeTab,
  onChange,
  tabs,
  className = '',
}: Props) {
  const handleChange = (tab: string) => onChange(tab);
  return (
    <div
      className={`w-fit max-sm:min-w-full transition-all duration-300 bg-gray-50 rounded-md flex items-center gap-2 p-0.5 border border-gray-100 max-w-full overflow-x-auto ${className}`}
    >
      {tabs.map((tab, index) => (
        <button
          key={index}
          onClick={() =>
            handleChange(typeof tab === 'string' ? tab : tab.value)
          }
          className={`p-2 max-sm:flex-1 max-sm:min-w-fit capitalize text-nowrap rounded-sm ${activeTab == (typeof tab == 'string' ? tab : tab.value) ? 'text-white bg-customs-bright-cyan' : 'bg-transparent medium-emphasis-text'}`}
        >
          {typeof tab === 'string' ? tab : tab.label}
        </button>
      ))}
    </div>
  );
}
